<template>
  <div>
    <app-overlay-loader v-if="!dataLoaded"/>
    <div class="content-wrapper" v-else>
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <app-breadcrumb
              :page-title="name"
              :directory="[$t('contacts'), name]"
              :icon="'users'"
              :button="{label: $t('back'), url:urlGenerator(`crm/person/list`)}"
          />
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
            <button
                type="button"
                class="btn btn-primary btn-with-shadow"
                data-toggle="modal"
                @click="openDealModal()"
            >{{ $t('add_deal') }}
            </button>
          </div>
        </div>
      </div>

      <person-user-info :personUserInfo="formData" @update-request="updateRequest"/>

      <div class="row">
        <div class="col-xl-4">
          <details-person
              class="mb-primary"
              :detailsData="formData"
              @update-request="updateRequest"
          />

          <component
              is="job-organization"
              v-if="isComponent"
              class="mb-primary"
              :organizationJob="formData.organizations"
              :person="formData.id"
              @update-request="updateRequest"
          />

          <contact-info-person
              :personContactInfo="formData"
              @update-request="updateRequest"
          />

          <deals-person
              class="mb-primary"
              :dealPerson="formData.deals"
              :personId="formData.id"
              :peopleList="peopleList"
              :totalDeals="formData.total_deals"
          />

          <tags-person class="mb-primary" :tagData="formData.tags" :person="formData.id"/>

          <followers-person
              class="mb-primary"
              :followerData="formData"
              :peopleList="peopleList"
              @update-request="updateRequest"
          />
        </div>
        <div class="col-xl-8">
          <app-tab class="mb-primary" type="horizontal" :tabs="todoActivityTab" v-if="appTapShow"/>
          <div class="activity-filter-wrapper">
            <template v-for="(filter, index) in activitiesFilter">
              <button
                  class="btn btn-sm px-3 rounded-pill primary-card-color mr-2"
                  :class="[value === filter.key ? 'text-primary' : index === 0 && value === '' ? 'text-primary': 'text-muted']"
                  @click.prevent="filterActivities(activitiesFilterUrl, filter.key)"
              >{{ filter.name }}
              </button>
            </template>

            <div class="mt-2 activity-filtered-result-wrapper">
              <template v-if="preLoader"></template>
              <template v-else>
                <template v-if="activitiesList.length < 1">
                  <div class="card card-with-shadow border-0">
                    <div class="card-body">
                      <template v-for="filter in activitiesFilter">
                        <app-empty-data-block
                            v-if="value === filter.key"
                            :key="filter.key"
                            :message="$t('please_add_something_in') + filter.name"
                        />
                      </template>
                    </div>
                  </div>
                </template>
              <div v-else :class="{'mb-2': activitiesList.length > 0}"
                   v-for="(activity, index) in activitiesList" :key="index">
                <div class="card card-with-shadow border-0">
                  <div class="card-body">
                    <div class="d-flex justify-content-between mb-3">
                      <div class="d-flex align-items-center">
                        <div
                            class="d-flex align-items-center justify-content-center primary-text-color mr-2 activity-icon"
                        >
                          <app-icon stroke-width="1" :name="activity.icon"/>

                        </div>
                        <div>
                          <h6 v-if="activity.title">{{ activity.title }} </h6>
                          <h6 v-if="activity.path">{{ activity.path.split("/").pop() }} </h6>
                          <h6 v-if="activity.note" v-html="textTruncate(activity.note, 15)">{{ $t('note') }}</h6>
                          <div class="d-flex align-items-center font-size-70">
                            <label
                                v-if="activity.status_id == 9"
                                class="customized-radio mini radio-default mr-0"
                            >
                              <input
                                  type="radio"
                                  class="radio-inline"
                                  :disabled="$can('update_activities') && $can('done_activities') ? false : true"
                                  @click="activityChangeStatus(activity.id)"
                              />
                              <span class="outside">
                                <span class="inside"/>
                              </span>
                            </label>

                            <div v-if="activity.started_at" class="text-success">
                              <span
                                  v-if="activity.started_at == today.dateOnly "
                              >{{ $t('today') }} | {{
                                  onlyTimeFromTime(activity.started_at, activity.start_time)
                                }}</span>
                              <span
                                  v-else-if="activity.ended_at < today.dateOnly "
                              >{{ $t('yesterday') }} | {{
                                  onlyTimeFromTime(activity.started_at, activity.start_time)
                                }}</span>
                              <span
                                  v-else
                              >{{
                                  formatDateToLocal(activity.started_at, true, activity.start_time)
                                }} | {{ formatDateToLocal(activity.ended_at, true, activity.end_time) }}</span>
                            </div>

                            <div v-else class="text-success">
                              <span>{{
                                  formatDateToLocal(activity.created_at, true)
                                }} | {{ onlyTime(activity.created_at) }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                          v-if="activity.status_id == 9 && (($can('update_activities') && $can('done_activities')) || $can('delete_activities'))"
                          class="dropdown options-dropdown">
                        <button type="button" class="btn-option btn" data-toggle="dropdown">
                          <app-icon name="more-vertical"/>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right py-2 mt-1 text-muted">
                          <a
                              v-if="$can('update_activities')"
                              class="dropdown-item font-size-80 px-4 py-2"
                              href="#"
                              @click.prevent="editActivity(activity)"
                          >{{ $t('edit') }}</a>
                          <a
                              v-if="$can('update_activities') && $can('done_activities')"
                              class="dropdown-item font-size-80 px-4 py-2"
                              href="#"
                              @click.prevent="activityChangeStatus(activity.id)"
                          >{{ $t('mark_as_done') }}</a>
                          <a
                              v-if="$can('delete_activities')"
                              class="dropdown-item font-size-80 px-4 py-2"
                              href="#"
                              @click.prevent="activityDelete(activity.id)"
                          >{{ $t('delete') }}</a>
                        </div>
                      </div>

                      <div v-if="activity.path" class="dropdown options-dropdown">
                        <button type="button" class="btn-option btn" data-toggle="dropdown">
                          <app-icon name="more-vertical"/>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right py-2 mt-1 text-muted">
                          <a
                              class="dropdown-item font-size-80 px-4 py-2"
                              href="#"
                              @click.prevent="fileDownload(activity)"
                          >{{ $t('download') }}</a>
                        </div>
                      </div>

                      <div v-if="activity.note" class="dropdown options-dropdown">
                        <button type="button" class="btn-option btn" data-toggle="dropdown">
                          <app-icon name="more-vertical"/>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right py-2 mt-1 text-muted">
                          <a
                              class="dropdown-item font-size-80 px-4 py-2"
                              href="#"
                              @click.prevent="editNote(activity)"
                          >{{ $t('edit') }}</a>
                          <a
                              class="dropdown-item font-size-80 px-4 py-2"
                              href="#"
                              @click.prevent="noteDelete(activity.id)"
                          >{{ $t('delete') }}</a>
                        </div>
                      </div>
                    </div>
                    <div v-if="activity.note" class="note p-2 mb-3 note-warning">
                      <p class="m-1" v-html="textTruncate(activity.note, 60)"></p>
                    </div>
                    <div class="mb-3 d-flex flex-wrap align-items-center">
                      <div class="d-flex align-items-center mr-3" v-if="formData.owner">
                        <app-avatar
                            class="mr-2"
                            :title="formData.owner.full_name"
                            :avatar-class="'avatars-w-30'"
                            :img="formData.owner.profile_picture ?
                                                            urlGenerator(formData.owner.profile_picture.path) :
                                                            formData.owner.profile_picture"
                        />
                        <span class="text-muted">{{ formData.owner.full_name }}</span>
                      </div>

                      <div
                          class="d-flex align-items-center mr-3"
                          v-if="formData.organizations.length == 1"
                          v-for="organization in formData.organizations"
                      >
                          <span class="mr-2 text-secondary org-icon"
                          ><app-icon :name="'briefcase'"></app-icon
                          ></span>
                        <span class="text-muted">{{
                            organization.name
                          }}</span>
                      </div>
                    </div>

                    <div v-if="isfileNoteFilter">
                      <p v-if="formData.organizations.length > 1" class="d-flex flex-wrap align-items-center">
                        {{ $t("organizations:") }}
                      </p>

                      <div v-bind:class="{'mb-3': activity.participants.length > 0,}"
                           class="d-flex justify-content-start">
                        <span
                            class="mr-3"
                            v-if="formData.organizations.length > 1"
                            v-for="organization in formData.organizations"
                        >
                          <span class="mr-2 text-secondary org-icon"
                          ><app-icon :name="'briefcase'"></app-icon
                          ></span>
                        <span class="text-muted">{{
                            organization.name
                          }}</span>
                      </span>
                      </div>


                      <p v-if="activity.participants.length" class="d-flex flex-wrap align-items-center">
                        {{ $t("participants:") }}
                      </p>
                      <div v-bind:class="{'mb-3': activity.collaborators.length > 0,}"
                           class="d-flex flex-wrap align-items-center">
                        <div
                            class="mb-1 d-flex align-items-center mr-3"
                            v-for="participant in participants"
                            v-if="activity.id == participant.pivot.activity_id"
                        >
                          <app-avatar
                              :title="participant.name"
                              class="mr-2"
                              :avatar-class="'avatars-w-30'"
                              :img="''"
                          />
                          <span class="text-muted">{{
                              participant.name
                            }}</span>
                        </div>
                      </div>
                      <p v-if="activity.collaborators.length" class="d-flex flex-wrap align-items-center">
                        {{ $t("collaborators:") }}
                      </p>
                      <div class="d-flex flex-wrap align-items-center">
                        <div
                            class="d-flex align-items-center mr-3"
                            v-for="collaborator in collaborators"
                            v-if="activity.id == collaborator.pivot.activity_id"
                        >
                          <app-avatar
                              :title="collaborator.full_name"
                              class="mr-2"
                              :avatar-class="'avatars-w-30'"
                              :img="''"
                          />
                          <span class="text-muted">{{
                              collaborator.full_name
                            }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </template>
            </div>
          </div>

        </div>
      </div>

      <app-deal-modal
          v-if="isDealModalActive"
          :pre-selected-option="{'person_id':formData.id}"
          @close-modal="closeDealModal"
      />


      <app-common-activity-modal
          v-if="personActivitiesModal"
          :activity="rowData"
          :selected-url="editedUrl"
          @close-modal="closeActivityModal"
      />

      <app-common-note-modal v-if="isNoteModal" :note="noteRowData" @close-modal="closeNoteModal"/>

    </div>
  </div>
</template>

<script>
import {FormMixin} from "@core/mixins/form/FormMixin.js";
import {formatDateToLocal, textTruncate, onlyTime, onlyTimeFromTime, urlGenerator} from "@app/Helpers/helpers";
import ActivityMixin from "@app/Mixins/Global/ActivityMixin";
import {collect} from "@app/Helpers/Collection";

export default {
  props: ["selectedUrl"],
  name: "PersonDetails",
  mixins: [FormMixin, ActivityMixin],

  components: {
    "person-user-info": require("./Details/PersonUserInfo").default,
    "details-person": require("./Details/DetailsPerson").default,
    "job-organization": require("./Details/OrganizationJob").default,
    "deals-person": require("./Details/DealsPerson").default,
    "tags-person": require("./Details/TagsPerson").default,
    "followers-person": require("./Details/FollowerPerson").default,
    "contact-info-person": require("./Details/PersonContactInfo").default,
  },
  data() {
    return {
        urlGenerator,
      dataLoaded: false,
      preLoader: false,
      isDealModalActive: false,
      isNoteModal: false,
      personActivitiesModal: false,
      formData: {},
      appTapShow: false,
      isComponent: true,
      name: "",
      editedUrl: "",
      activitiesList: [],
      collaborators: [],
      participants: [],
      isfileNoteFilter: true,

      // Tab Start
      todoActivityTab: [
        {
          name: "activity",
          icon: "activity",
          component: "common-activity-tab",
          props: "",
          permission: "",
        },
        {
          name: "file",
          icon: "paperclip",
          component: "common-file-tab",
          props: "",
          permission: "",
        },
        {
          name: "note",
          icon: "file-text",
          component: "common-note-tab",
          props: "",
          permission: "",
        },
      ],


      rowData: null,
      dealNoteModal: false,
      noteRowData: null,
      value: "",
      formatDateToLocal,
      onlyTimeFromTime,
      onlyTime,
      textTruncate,
      activitiesFilterUrl: "crm/person/activities/",
    };
  },
  computed: {
    peopleList() {
      return this.$store.getters.getPerson
    },
  },
  methods: {
    afterSuccessFromGetEditData(response) {
      this.formData = response.data;
      this.name = this.formData.name;
      this.todoActivityTab.forEach((el) => {
        el["props"] = {
          id: this.formData.id,
          person: "person",
          contextable_type: "App\\Models\\CRM\\Person\\Person",
          activitySyncUrl: `crm/person/activities/sync/${this.formData.id}`,
          fileSyncUrl: `crm/person/file/sync/${this.formData.id}`,
          noteSyncUrl: `crm/person/note/sync/${this.formData.id}`,
        };
      });


      // Collaborator Group by
      this.formData.activity.forEach((element, index) => {
        element.collaborators.forEach((item, index) => {
          this.collaborators.push(item);
        });
      });

      // Participant Group By
      this.formData.activity.forEach((element, index) => {
        element.participants.forEach((item, index) => {
          this.participants.push(item);
        });
      });


      this.appTapShow = true;
      this.filterActivities(this.activitiesFilterUrl, "status=9");
      this.dataLoaded = true;
    },

    filterActivities(url, key) {
      this.preLoader = true;
      this.value = key;
      if (key == "file" || key == "note") {
        this.isfileNoteFilter = false;
        this.axiosGet(`crm/person/${this.formData.id}/${key}`).then((response) => {
          this.activitiesList = response.data;
        }).finally(() => {
          this.preLoader = false;
        }).catch((error) => console.log(error));
      } else {
        this.isfileNoteFilter = true;
        this.axiosGet(`${url}${this.formData.id}?${this.value}`)
            .then((response) => {
              this.activitiesList = response.data;
            }).finally(() => {
          this.preLoader = false;
        }).catch((error) => console.log(error));
      }
    },
    updateActivity() {
      this.$hub.$on("activity-list", (value = true) => {
        if (value) {
          this.personUpdateRequest();
          this.filterActivities(this.activitiesFilterUrl, "status=9");
        }
      });
    },

    updateRequest() {
      this.isComponent = false;
      this.axiosGet(this.selectedUrl).then((response) => {
            this.formData = response.data;
            this.name = this.formData.name;
            this.isComponent = true;
          }).catch((error) => console.log(error));
    },
    personUpdateRequest() {
      this.collaborators = [];
      this.participants = [];
      this.axiosGet(this.selectedUrl)
          .then(({data}) => {
            this.formData = data;

            // Collaborator Group by
            this.formData.activity.forEach((element, index) => {
              element.collaborators.forEach((item, index) => {
                this.collaborators.push(item);
              });
            });

            // Participant Group By
            this.formData.activity.forEach((element, index) => {
              element.participants.forEach((item, index) => {
                this.participants.push(item);
              });
            });
          })
          .catch((error) => console.log(error));
    },
    updateDealList() {
      this.$hub.$on("deal-update-list", (value = true) => {
        if (value) {
          this.updateRequest();
        }
      });
    },
    updateTagList() {
      this.$hub.$on("tag-list", (value = true) => {
        if (value) {
          this.updateRequest();
        }
      });
    },

    editActivity(activity) {
      this.editedUrl = `crm/activities/${activity.id}`;
      this.rowData = activity;
      this.personActivitiesModal = true;
    },
    openDealModal() {
      this.isDealModalActive = true;
      setTimeout(function () {
        $("#deal-modal").modal("show");
      });
    },
    closeDealModal() {
      this.isDealModalActive = false;
      $("#deal-modal").modal("hide");
    },
    closeActivityModal() {
      this.personActivitiesModal = false;
      $("#common-activity-modal").modal("hide");
    },

    editNote(activity) {
      this.isNoteModal = true;
      this.noteRowData = activity;
      setTimeout(() => {
        $("#note-modal").modal("show");
      });
    },
    closeNoteModal() {
      this.isNoteModal = false;
      $("#note-modal").modal("hide");
    },
  },

  mounted() {
    this.updateDealList();
    this.updateTagList();
    this.updateActivity();
    this.$store.dispatch("getPerson");
    this.$store.dispatch('getOrganization');
  },
};
</script>
